import React, { useEffect, useState } from "react";
import CustomLoader from "./../../common/CustomLoader";
import { useAIAskMeContext } from "../../../context/ai-ask-me.context";
import { useAppContext } from "../../../context/app.context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComment, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { GroupByType } from "../../../helper/constant";
import { ageAgo } from "../../../helper/helper";
import { Link } from "react-router-dom";
import { deleteChatHistory } from "../../../service/ai-model.service";

const ChatbotHistory = () => {
  const { isLoading } = useAppContext();
  const {
    getQueryHistory,
    queryHistory,
    showModal,
    updateCurrentQueryUUID,
    updateCurrentQuery
  } = useAIAskMeContext();

  useEffect(() => {
    if (showModal) {
      getQueryHistory();
    }
  }, [showModal]);

  const onDeleteChatHistory = (e, item) => {
    e.stopPropagation();
    deleteChatHistory({ name: item.name })
      .then((res) => getQueryHistory())
      .catch((ex) => console.error(ex));
  }

  const renderHistory = () => {
    if (queryHistory.length)
      return queryHistory.map((item, key) => (
        <div
          key={`query-${key}`}
          onClick={() => {
            updateCurrentQueryUUID(item.sessionId);
            updateCurrentQuery(null);
          }}
          className="py-2 text-white cursor-pointer d-flex align-items-center gap-1 pr-2"
        >
          <FontAwesomeIcon icon={faComment} />
          <div className="text-wrap">{item.sessionId}</div>
          <Link onClick={(e) => onDeleteChatHistory(e, item, key)} className="text-danger"> <FontAwesomeIcon icon={faTrashCan} /></Link>
        </div>
      ))

    return <p>No data available</p>;
  };

  const onNewChat = () => {
    updateCurrentQueryUUID(null);
    updateCurrentQuery("");
  }
  const render = () => {
    return (
      <div className="chatbotsidebar position-relative px-3 py-4">
        <button className="btn1 py-2 px-0 font-weight-bold w-100 my-3" onClick={() => onNewChat()}>
          <FontAwesomeIcon icon={faComment} /> <span className="pl-1">New Chat</span>
        </button>
        <h3 className="h6 font-weight-bold text-white">History</h3>
        <div className="font-14 text-secondary mt=y-3">Recent Queries</div>
        <div className="mx-h-65 d-flex flex-column ">
          {!isLoading && renderHistory()}
        </div>
        {isLoading && (
          <div className="d-flex justify-content-center">
            <CustomLoader />
          </div>
        )}
      </div>
    );
  };
  return render();
};

export default ChatbotHistory;
